import React, { PureComponent } from 'react';
import { parsePrice } from '../../../../../../../lib/helper.js';

const COST_MESSAGE = ' will be added to item price.';

class CostDisplay extends PureComponent {

  parseModifierCost(cost) {
    if (cost && cost.toString().replace(/[0.,\t\s]/g, '').length > 0) {
      return parsePrice(cost);
    } else {
      return '';
    }
  }

  render() {
    const { cost } = this.props;
    const parsedCost = this.parseModifierCost(cost);
    return ( parsedCost ?
        <strong title={parsedCost + COST_MESSAGE}>
          {` (+ ${parsedCost})`}
        </strong>
        :
        null
);
  }
}

export default CostDisplay;



// WEBPACK FOOTER //
// ./src/views/dashboard/components/items/components/PizzaCreatorModifiers/ModifierInput/CostDisplay.jsx